var React = require('react');
var labels = require('MemberJoinLabels');


class AutoRenewInformation extends React.Component {
    constructor(props) {
        super(props);

        this.handleautorenewflagChange = this.handleautorenewflagChange.bind(this);
        this.clearautorenewflag = this.clearautorenewflag.bind(this);
    }



    handleautorenewflagChange(event) {


        if (event.target.checked) {
            this.props.updateStepState('autorenewflag', 1)
        } else {
            this.clearautorenewflag();
        }
    }

    clearautorenewflag() {
        this.props.updateStepState('autorenewflag', 0);
    }

    render() {

        if (this.props.getInfoModalContent("AutoRenew").enable == 'true') {
            return (

                <div className={"autorenew-information-container"}>
                    <div className={"row"}>
                        <div className={"panel"}>
                            <div className={"col-md-12"}>
                                <h3>{labels.step6.AutorenewInformation}</h3>
                                <div><label className={"memberjoin"} style={{ display: "inline" }} htmlFor="autorenewtext">{labels.step6.Autorenewagreement}</label></div>
                            </div>
                            <div className={"edit"}>
                                <div className={"col-md-6 autorenewInfo"}>
                                    <input type="checkbox"
                                        id="autorenew"
                                        name="auotrenewforpayment"
                                        checked={this.props.stepState.autorenewflag}
                                        onChange={this.handleautorenewflagChange}
                                    />
                                    {this.props.getInfoModalContent("AutoRenew").infoIconLabel}
                                    <span className={"get-info"} onClick={() => { return this.props.showInfoModal('AutoRenew') }} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>);
        }
        else {
            return (null);
        }

    }
}
module.exports = AutoRenewInformation;
